import { render } from "./RectangleEditor.vue?vue&type=template&id=eb5c8d48&scoped=true"
import script from "./RectangleEditor.vue?vue&type=script&lang=ts"
export * from "./RectangleEditor.vue?vue&type=script&lang=ts"

import "./RectangleEditor.vue?vue&type=style&index=0&id=eb5c8d48&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-eb5c8d48"

export default script